module.exports = __webpack_public_path__ + "img/nacimientos-itamar-thumbnail.53194f78.jpg";